'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotifyResize = undefined;

var _src = require('./src');

Object.defineProperty(exports, 'NotifyResize', {
  enumerable: true,
  get: function get() {
    return _src.NotifyResize;
  }
});

var _src2 = _interopRequireDefault(_src);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _src2.default;
